import { common } from './sections/common';
import { home } from './sections/home';
import { country, cities, cityPage, poiPage, airportPage } from './sections/country';
import { transport, insurance, stay, tours, esim } from './sections/services';
import { faqSubpage, esimPromotions, esimDeviceCheck, esimQuiz, countryQuiz } from './sections/subpages';
import { privacy, disclaimer, contact } from './sections/legal';
import { blog } from './sections/blog';
import { providerPage } from './sections/provider';
import { servicePage } from './sections/servicePage';
import { insurancePage } from './sections/insurancePage';
import { vpnPage } from './sections/vpnPage';
import { transportPage } from './sections/transportPage';
import { stayPage } from './sections/stayPage';
import { toursPage } from './sections/toursPage';
import { esimPage } from './sections/esimPage';
import { countryPage } from './sections/countryPage';
import { citiesPage } from './sections/citiesPage';
import { cityPageUi } from './sections/cityPageUi';
import { poiPageUi } from './sections/poiPageUi';
import { airportPageUi } from './sections/airportPageUi';
import { esimPlansLedger } from './sections/esimPlansLedger';
import { allHotelsPage } from './sections/allHotelsPage';
import { blogUi } from './sections/blogUi';
import { esimToolsUi } from './sections/esimToolsUi';
import { mapsUi } from './sections/mapsUi';
import { serviceWidgetsUi } from './sections/serviceWidgetsUi';
import { countryWidgetsUi } from './sections/countryWidgetsUi';
import { accommodationUi } from './sections/accommodationUi';
import { toursWidgetsUi } from './sections/toursWidgetsUi';
import { miscUi } from './sections/miscUi';
import { staticPagesUi } from './sections/staticPagesUi';
import { ledgerLabels } from './sections/ledgerLabels';

const translations = {
    en: {
        common: common.en,
        transport: transport.en,
        insurance: insurance.en,
        cities: cities.en,
        stay: stay.en,
        tours: tours.en,
        home: home.en,
        country: country.en,
        cityPage: cityPage.en,
        poiPage: poiPage.en,
        airportPage: airportPage.en,
        esim: esim.en,
        faqSubpage: faqSubpage.en,
        esimPromotions: esimPromotions.en,
        esimDeviceCheck: esimDeviceCheck.en,
        esimQuiz: esimQuiz.en,
        countryQuiz: countryQuiz.en,
        privacy: privacy.en,
        disclaimer: disclaimer.en,
        contact: contact.en,
        blog: blog.en,
        providerPage: providerPage.en,
        servicePage: servicePage.en,
        insurancePage: insurancePage.en,
        vpnPage: vpnPage.en,
        transportPage: transportPage.en,
        stayPage: stayPage.en,
        toursPage: toursPage.en,
        esimPage: esimPage.en,
        countryPage: countryPage.en,
        citiesPage: citiesPage.en,
        cityPageUi: cityPageUi.en,
        poiPageUi: poiPageUi.en,
        airportPageUi: airportPageUi.en,
        esimPlansLedger: esimPlansLedger.en,
        allHotelsPage: allHotelsPage.en,
        blogUi: blogUi.en,
        esimToolsUi: esimToolsUi.en,
        mapsUi: mapsUi.en,
        serviceWidgetsUi: serviceWidgetsUi.en,
        countryWidgetsUi: countryWidgetsUi.en,
        accommodationUi: accommodationUi.en,
        toursWidgetsUi: toursWidgetsUi.en,
        miscUi: miscUi.en,
        staticPagesUi: staticPagesUi.en,
        ledgerLabels: ledgerLabels.en,
    },
    ru: {
        common: common.ru,
        transport: transport.ru,
        insurance: insurance.ru,
        cities: cities.ru,
        stay: stay.ru,
        tours: tours.ru,
        home: home.ru,
        country: country.ru,
        cityPage: cityPage.ru,
        poiPage: poiPage.ru,
        airportPage: airportPage.ru,
        esim: esim.ru,
        faqSubpage: faqSubpage.ru,
        esimPromotions: esimPromotions.ru,
        esimDeviceCheck: esimDeviceCheck.ru,
        esimQuiz: esimQuiz.ru,
        countryQuiz: countryQuiz.ru,
        privacy: privacy.ru,
        disclaimer: disclaimer.ru,
        contact: contact.ru,
        blog: blog.ru,
        providerPage: providerPage.ru,
        servicePage: servicePage.ru,
        insurancePage: insurancePage.ru,
        vpnPage: vpnPage.ru,
        transportPage: transportPage.ru,
        stayPage: stayPage.ru,
        toursPage: toursPage.ru,
        esimPage: esimPage.ru,
        countryPage: countryPage.ru,
        citiesPage: citiesPage.ru,
        cityPageUi: cityPageUi.ru,
        poiPageUi: poiPageUi.ru,
        airportPageUi: airportPageUi.ru,
        esimPlansLedger: esimPlansLedger.ru,
        allHotelsPage: allHotelsPage.ru,
        blogUi: blogUi.ru,
        esimToolsUi: esimToolsUi.ru,
        mapsUi: mapsUi.ru,
        serviceWidgetsUi: serviceWidgetsUi.ru,
        countryWidgetsUi: countryWidgetsUi.ru,
        accommodationUi: accommodationUi.ru,
        toursWidgetsUi: toursWidgetsUi.ru,
        miscUi: miscUi.ru,
        staticPagesUi: staticPagesUi.ru,
        ledgerLabels: ledgerLabels.ru,
    },
};

/**
 * Get translations for a given language and section.
 * @param {string} lang - 'en' or 'ru'
 * @param {string} section - e.g. 'home', 'common'
 * @returns {object} translation object for the section
 */
export function t(lang, section) {
    const locale = translations[lang] || translations.en;
    return locale[section] || {};
}

export default translations;
